import { useIsMounted } from 'js/hooks/useIsMounted';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';

import { useFetchSportsbookGamingHistory } from './useFetchSportsbookGamingHistory';

export const useFetchComponent = () => {
    const isMounted = useIsMounted();
    const fetchSportsbookGamingHistory = useFetchSportsbookGamingHistory();

    useUpdateEffect(() => {
        if (!isMounted()) {
            return;
        }

        fetchSportsbookGamingHistory();

    }, [isMounted, fetchSportsbookGamingHistory]);
};
